import React, { useState } from 'react';
import Heading from '../ui/Heading';
import Section from '../ui/Section';

const ProjectGallery = ({ images, videos }) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);


  const nextImage = () => {
    setCurrentImage((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const toggleFullscreen = () => {
    setIsFullscreen((prev) => !prev);
  };


  return (

    <>
      {/* Fullscreen Modal */}
      {isFullscreen && (
        <div className="fixed inset-0 z-50 bg-black flex items-center justify-center">
          <div className="relative w-full h-full">
            <img
              src={images[currentImage].url}
              alt={images[currentImage].alt}
              className="w-full h-full object-contain"
            />
            
            <div className="absolute top-4 right-4 flex space-x-3">
              <button
                onClick={toggleFullscreen}
                className="bg-white/20 hover:bg-white/40 text-white p-3 rounded-full shadow-md transition-all duration-200"
                aria-label="Exit fullscreen"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="4 14 10 14 10 20"></polyline>
                  <polyline points="20 10 14 10 14 4"></polyline>
                  <line x1="14" y1="10" x2="21" y2="3"></line>
                  <line x1="3" y1="21" x2="10" y2="14"></line>
                </svg>
              </button>
            </div>

            <div className="absolute bottom-6 right-6 flex space-x-3">
              <button
                onClick={prevImage}
                className="bg-white/20 hover:bg-white/40 text-white p-3 rounded-full shadow-md transition-all duration-200"
                aria-label="Previous image"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M15 18l-6-6 6-6" />
                </svg>
              </button>
              <button
                onClick={nextImage}
                className="bg-white/20 hover:bg-white/40 text-white p-3 rounded-full shadow-md transition-all duration-200"
                aria-label="Next image"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 18l6-6-6-6" />
                </svg>
              </button>
            </div>
            
            <div className="absolute bottom-6 left-6 bg-white/20 py-2 px-4 rounded-md">
              <p className="text-white text-sm">{currentImage + 1} / {images.length}</p>
            </div>
          </div>
        </div>
      )}

      {/* Main Image Viewer Section */}
      <Section className="py-6 sm:py-10 sm:px-5 lg:px-60">
        <div className="mx-auto">
          <Heading level="3" className="mb-8">Project Gallery</Heading>
          <div className="relative h-[400px] sm:h-[500px] w-full bg-gray-100 overflow-hidden rounded-lg">
            <img
              src={images[currentImage].url}
              alt={images[currentImage].alt}
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute top-4 right-4">
              <button
                onClick={toggleFullscreen}
                className="bg-white/80 hover:bg-white text-gray-800 p-3 rounded-full shadow-md transition-all duration-200"
                aria-label="View fullscreen"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="15 3 21 3 21 9"></polyline>
                  <polyline points="9 21 3 21 3 15"></polyline>
                  <line x1="21" y1="3" x2="14" y2="10"></line>
                  <line x1="3" y1="21" x2="10" y2="14"></line>
                </svg>
              </button>
            </div>
            <div className="absolute bottom-6 right-6 flex space-x-3">
              <button
                onClick={prevImage}
                className="bg-white/80 hover:bg-white text-gray-800 p-3 rounded-full shadow-md transition-all duration-200"
                aria-label="Previous image"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M15 18l-6-6 6-6" />
                </svg>
              </button>
              <button
                onClick={nextImage}
                className="bg-white/80 hover:bg-white text-gray-800 p-3 rounded-full shadow-md transition-all duration-200"
                aria-label="Next image"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 18l6-6-6-6" />
                </svg>
              </button>
            </div>
            <div className="absolute bottom-6 left-6 bg-white/80 py-2 px-4 rounded-md">
              <p className="text-gray-800 text-sm">{currentImage + 1} / {images.length}</p>
            </div>
          </div>
        </div>
      </Section>

      {/* Browse Images Section */}
      <Section className="py-6 sm:py-10 sm:px-5 lg:px-10 bg-gray-50">
        <div className="mx-auto">
          <h4 className="text-gray-600 font-medium mb-6 text-sm uppercase tracking-wider">Browse Images</h4>
          <div className="flex overflow-x-auto pb-4 scrollbar-hide gap-4">
            {images.map((image, index) => (
              <button
                key={index}
                onClick={() => setCurrentImage(index)}
                className={`flex-shrink-0 w-32 h-32 relative overflow-hidden rounded-md transition-all duration-300 ${
                  currentImage === index 
                    ? 'ring-2 ring-primary-500' 
                    : 'hover:shadow-lg'
                }`}
              >
                <img src={image.url} alt={image.alt} className="w-full h-full object-cover" />
                <div className={`absolute inset-0 ${currentImage === index ? 'bg-black/10' : 'bg-black/0 hover:bg-black/10'} transition-colors duration-300`}></div>
              </button>
            ))}
          </div>
        </div>
      </Section>

      {/* Video Section */}
      {videos && videos.length > 0 && (
        <Section className="py-6 sm:py-10 sm:px-5 lg:px-20">
          <div className="mx-auto">
            <Heading level="3" className="mb-8">Project Highlights</Heading>
            <div className={`grid grid-cols-1 ${videos.length > 1 ? 'lg:grid-cols-3' : ''} gap-10`}>
              {videos.map((video, index) => (
                <div key={index} className="flex flex-col">
                  {video.title && (
                    <h4 className="text-gray-700 font-medium mb-4 text-lg">
                      {video.title}
                    </h4>
                  )}
                  <div className="relative aspect-video w-full bg-gray-100 overflow-hidden rounded-lg shadow-md">
                    <iframe
                      src={video.url}
                      title={video.title || "Project Video"}
                      className="w-full h-full"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Section>
      )}
    </>
  );
};

export default ProjectGallery;